import {
  PURCHASE_DRAFT_LIST,
  PURCHASE_DRAFT_LIST_SUCCESS,
  PURCHASE_DRAFT_LIST_FAIL,
  PURCHASE_DRAFT_SEARCH,
  PURCHASE_DRAFT_SEARCH_SUCCESS,
  PURCHASE_DRAFT_SEARCH_FAIL,
  PURCHASE_DRAFT_DATA,
  PURCHASE_DRAFT_DATA_SUCCESS,
  PURCHASE_DRAFT_DATA_FAIL,
  PURCHASE_DRAFT_CREATE,
  PURCHASE_DRAFT_CREATE_SUCCESS,
  PURCHASE_DRAFT_CREATE_FAIL,
  PURCHASE_DRAFT_UPDATE,
  PURCHASE_DRAFT_UPDATE_SUCCESS,
  PURCHASE_DRAFT_UPDATE_FAIL,
  PURCHASE_DRAFT_DELETE,
  PURCHASE_DRAFT_DELETE_SUCCESS,
  PURCHASE_DRAFT_DELETE_FAIL,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS,
  PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL,
  PURCHASE_DRAFT_STATUS_LIST,
  PURCHASE_DRAFT_STATUS_LIST_SUCCESS,
  PURCHASE_DRAFT_STATUS_LIST_FAIL,
  PURCHASE_DRAFT_STATUS_DATA,
  PURCHASE_DRAFT_STATUS_DATA_SUCCESS,
  PURCHASE_DRAFT_STATUS_DATA_FAIL,
  PURCHASE_DRAFT_STATUS_CREATE,
  PURCHASE_DRAFT_STATUS_CREATE_SUCCESS,
  PURCHASE_DRAFT_STATUS_CREATE_FAIL,
  PURCHASE_DRAFT_STATUS_UPDATE,
  PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS,
  PURCHASE_DRAFT_STATUS_UPDATE_FAIL,
  PURCHASE_DRAFT_STATUS_DELETE,
  PURCHASE_DRAFT_STATUS_DELETE_SUCCESS,
  PURCHASE_DRAFT_STATUS_DELETE_FAIL,
} from "./actionType";

//PURCHASE_DRAFT_LIST
export const getPurchaseDraftList = () => {
  return {
    type: PURCHASE_DRAFT_LIST,
  };
};
export const getPurchaseDraftListSuccess = (purchaseDraftList) => {
  return {
    type: PURCHASE_DRAFT_LIST_SUCCESS,
    payload: purchaseDraftList,
  };
};
export const getPurchaseDraftListFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_LIST_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_SEARCH
export const getPurchaseDraftSearch = (search) => {
  return {
    type: PURCHASE_DRAFT_SEARCH,
    payload: search,
  };
};
export const getPurchaseDraftSearchSuccess = (purchaseDraftList) => {
  return {
    type: PURCHASE_DRAFT_SEARCH_SUCCESS,
    payload: purchaseDraftList,
  };
};
export const getPurchaseDraftSearchFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_SEARCH_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_DATA
export const getPurchaseDraftData = (id) => {
  return {
    type: PURCHASE_DRAFT_DATA,
    payload: id,
  };
};
export const getPurchaseDraftDataSuccess = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_DATA_SUCCESS,
    payload: purchaseDraft,
  };
};
export const getPurchaseDraftDataFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_DATA_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_CREATE
export const createPurchaseDraft = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_CREATE,
    payload: purchaseDraft,
  };
};
export const createPurchaseDraftSuccess = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_CREATE_SUCCESS,
    payload: purchaseDraft,
  };
};
export const createPurchaseDraftFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_CREATE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_UPDATE
export const updatePurchaseDraft = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_UPDATE,
    payload: purchaseDraft,
  };
};
export const updatePurchaseDraftSuccess = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_UPDATE_SUCCESS,
    payload: purchaseDraft,
  };
};
export const updatePurchaseDraftFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_UPDATE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_DELETE
export const deletePurchaseDraft = (id) => {
  return {
    type: PURCHASE_DRAFT_DELETE,
    payload: id,
  };
};
export const deletePurchaseDraftSuccess = (id) => {
  return {
    type: PURCHASE_DRAFT_DELETE_SUCCESS,
    payload: id,
  };
};
export const deletePurchaseDraftFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_DELETE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_CONVERT_TO_PURCHASE
export const convertToPurchase = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_CONVERT_TO_PURCHASE,
    payload: purchaseDraft,
  };
};
export const convertToPurchaseSuccess = (purchaseDraft) => {
  return {
    type: PURCHASE_DRAFT_CONVERT_TO_PURCHASE_SUCCESS,
    payload: purchaseDraft,
  };
};
export const convertToPurchaseFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_CONVERT_TO_PURCHASE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_STATUS_LIST
export const getPurchaseDraftStatusList = () => {
  return {
    type: PURCHASE_DRAFT_STATUS_LIST,
  };
};
export const getPurchaseDraftStatusListSuccess = (purchaseDraftStatusList) => {
  return {
    type: PURCHASE_DRAFT_STATUS_LIST_SUCCESS,
    payload: purchaseDraftStatusList,
  };
};
export const getPurchaseDraftStatusListFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_STATUS_LIST_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_STATUS_DATA
export const getPurchaseDraftStatusData = (id) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DATA,
    payload: id,
  };
};
export const getPurchaseDraftStatusDataSuccess = (purchaseDraftStatus) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DATA_SUCCESS,
    payload: purchaseDraftStatus,
  };
};
export const getPurchaseDraftStatusDataFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DATA_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_STATUS_CREATE
export const createPurchaseDraftStatus = (purchaseDraftStatus) => {
  return {
    type: PURCHASE_DRAFT_STATUS_CREATE,
    payload: purchaseDraftStatus,
  };
};
export const createPurchaseDraftStatusSuccess = (purchaseDraftStatus) => {
  return {
    type: PURCHASE_DRAFT_STATUS_CREATE_SUCCESS,
    payload: purchaseDraftStatus,
  };
};
export const createPurchaseDraftStatusFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_STATUS_CREATE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_STATUS_UPDATE
export const updatePurchaseDraftStatus = (purchaseDraftStatus) => {
  return {
    type: PURCHASE_DRAFT_STATUS_UPDATE,
    payload: purchaseDraftStatus,
  };
};
export const updatePurchaseDraftStatusSuccess = (purchaseDraftStatus) => {
  return {
    type: PURCHASE_DRAFT_STATUS_UPDATE_SUCCESS,
    payload: purchaseDraftStatus,
  };
};
export const updatePurchaseDraftStatusFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_STATUS_UPDATE_FAIL,
    payload: error,
  };
};
//PURCHASE_DRAFT_STATUS_DELETE
export const deletePurchaseDraftStatus = (id) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DELETE,
    payload: id,
  };
};
export const deletePurchaseDraftStatusSuccess = (id) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DELETE_SUCCESS,
    payload: id,
  };
};
export const deletePurchaseDraftStatusFailure = (error) => {
  return {
    type: PURCHASE_DRAFT_STATUS_DELETE_FAIL,
    payload: error,
  };
};
